import { RootState } from '../types'

export const getMainProductSelector = (state: RootState) => state.product
